import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

// Actions
import { setType } from "redux/landing/wheels/slice";

// Components
import Wheel from "components/organisms/Wheel";

// Constants
import { STORAGE_LANGUAGE_NAME } from "constants/variables";

// Selectors
import * as wheelSelector from "redux/landing/wheels/selectors";

// Types
import { WheelType } from "types/Wheel";

const WheelContainer = () => {
  const { idle, type } = useSelector(wheelSelector.all);
  const location = useLocation().pathname;
  const dispatch = useDispatch();
  const girl = location.includes(WheelType.GIRLS);
  const girlBangladesh = location.includes(WheelType.GIRLS_BANGLADESH);
  const teenagers = location.includes(WheelType.TEENAGERS);
  const cards = location.includes(WheelType.CARDS);
  const aviator = location.includes(WheelType.AVIATOR);
  const chicksTurkey = location.includes(WheelType.CHICKS_TURKEY);
  const chicksBangladesh = location.includes(WheelType.CHICKS_BANGLADESH);
  const chicksUzbekistan = location.includes(WheelType.CHICKS_UZBEKISTAN);
  const chicksAzer = location.includes(WheelType.CHICKS_AZER);
  const crazyTime = location.includes(WheelType.CRAZY_TIME);
  const roulette = location.includes(WheelType.ROULETTE);
  const sweetBonanza = location.includes(WheelType.SWEET_BONANZA);
  const olympus = location.includes(WheelType.GATES_OLYMPUS);

  useEffect(() => {
    if (girlBangladesh) {
      dispatch(setType(WheelType.GIRLS_BANGLADESH));
      localStorage.setItem(STORAGE_LANGUAGE_NAME, "BN");
    } else if (girl) {
      dispatch(setType(WheelType.GIRLS));
    } else if (teenagers) {
      dispatch(setType(WheelType.TEENAGERS));
    } else if (cards) {
      dispatch(setType(WheelType.CARDS));
    } else if (aviator) {
      dispatch(setType(WheelType.AVIATOR));
    } else if (crazyTime) {
      dispatch(setType(WheelType.CRAZY_TIME));
    } else if (chicksTurkey) {
      dispatch(setType(WheelType.CHICKS_TURKEY));
      localStorage.setItem(STORAGE_LANGUAGE_NAME, "TR");
    } else if (chicksBangladesh) {
      dispatch(setType(WheelType.CHICKS_BANGLADESH));
      localStorage.setItem(STORAGE_LANGUAGE_NAME, "BN");
    } else if (chicksUzbekistan) {
      dispatch(setType(WheelType.CHICKS_UZBEKISTAN));
      localStorage.setItem(STORAGE_LANGUAGE_NAME, "UZ");
    } else if (roulette) {
      dispatch(setType(WheelType.ROULETTE));
    } else if (sweetBonanza) {
      dispatch(setType(WheelType.SWEET_BONANZA));
    } else if (olympus) {
      dispatch(setType(WheelType.GATES_OLYMPUS));
    } else if (chicksAzer) {
      dispatch(setType(WheelType.CHICKS_AZER));
      localStorage.setItem(STORAGE_LANGUAGE_NAME, "AZ");
    } else {
      dispatch(setType(WheelType.INITIAL));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    chicksTurkey,
    cards,
    aviator,
    girl,
    teenagers,
    chicksBangladesh,
    chicksUzbekistan,
    crazyTime,
    roulette,
    sweetBonanza,
    chicksAzer,
    olympus,
  ]);

  return <Wheel idle={idle} type={type} />;
};

export default WheelContainer;
